/* Header entry point for the existing diesel-only finder. No catalogue filtering here. */
(function () {
  'use strict';
  if (customElements.get('jss-header-vehicle')) return;
  const core = window.JSDieselFitment;
  const vehicle = window.JSSVehicle;
  if (!core || !vehicle) return;
  class HeaderVehicle extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.link = this.querySelector('[data-header-vehicle-link]');
      this.heading = this.querySelector('[data-header-vehicle-heading]');
      this.value = this.querySelector('[data-header-vehicle-value]');
      this.change = this.querySelector('[data-header-vehicle-change]');
      if (!this.link || !this.heading || !this.value || !this.change) return;
      this.events = new AbortController();
      window.addEventListener('jss:vehicle-change', () => this.refresh(), { signal:this.events.signal });
      this.link.setAttribute('aria-controls', 'JssVehiclePanel');
      this.link.setAttribute('aria-expanded', 'false');
      this.link.addEventListener('click', event => {
        const panel = document.querySelector('jss-vehicle-panel');
        if (!panel?.open || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        panel.open(this.link);
      }, { signal: this.events.signal });
      this.querySelectorAll('[data-vehicle-brand]').forEach(image => {
        image.addEventListener('load', () => { image.dataset.loaded = 'true'; this.refresh(); }, { signal: this.events.signal });
        image.addEventListener('error', () => { image.dataset.failed = 'true'; this.refresh(); }, { signal: this.events.signal });
      });
      this.refresh();
    }
    disconnectedCallback() { this.events?.abort(); this.events = null; }
    refresh() {
      const record = vehicle.get();
      const values = record?.values || {};
      const complete = core.vehicleKeys.every(key => values[key]);
      const label = ['make', 'year', 'model', 'engine'].map(key => values[key]).filter(Boolean).join(' ');
      const fullLabel = ['make', 'year', 'model', 'engine', 'type', 'body'].map(key => values[key]).filter(Boolean).join(' ');
      this.dataset.state = complete ? 'selected' : record ? 'partial' : 'empty';
      this.heading.textContent = 'Diesel parts finder';
      const normalizeMake = value => String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
      const logos = [...this.querySelectorAll('[data-vehicle-brand]')];
      const logo = complete ? logos.find(image => image.dataset.failed !== 'true' && image.dataset.vehicleBrand.split(',').some(make => normalizeMake(make) === normalizeMake(values.make))) : null;
      if (logo && !logo.getAttribute('src')) logo.src = logo.dataset.logoSrc;
      const showLogo = logo?.dataset.loaded === 'true';
      logos.forEach(image => { image.hidden = image !== logo || !showLogo; });
      this.querySelector('.jss-header-vehicle__icon').toggleAttribute('hidden', Boolean(showLogo));
      const visibleLabel = showLogo ? ['year', 'model', 'engine'].map(key => values[key]).filter(Boolean).join(' ') : label;
      this.value.textContent = complete ? visibleLabel : record ? 'Complete your vehicle details' : 'Select your vehicle';
      this.change.hidden = !complete;
      this.link.setAttribute('aria-label', complete ? 'Change vehicle for diesel parts. ' + fullLabel : record ? 'Complete your diesel vehicle details. ' + fullLabel : 'Select your vehicle for the diesel parts finder');
      this.link.title = complete ? fullLabel + '. Change vehicle for diesel parts.' : 'Find supported diesel parts. Holley and other performance parts are not included.';
      const url = new URL(this.dataset.finderUrl, location.href);
      if (url.origin !== location.origin) return;
      url.searchParams.set('view', 'js-diesel-fitment');
      url.searchParams.set('jsdf_open', '1');
      for (const key of core.keys) if (values[key]) url.searchParams.set(core.params[key], values[key]);
      if (complete && core.vehicleKeys.every(key => record.confirmedKeys.includes(key))) url.searchParams.set('jsdf_confirmed', '1');
      const preview = new URL(location.href).searchParams.get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      this.link.href = url.href;
    }
  }
  customElements.define('jss-header-vehicle', HeaderVehicle);
})();
